export default __webpack_public_path__ + "static/media/about-us-icon-geedop-park.bffbd07d.png";